import type { TranslocoService } from '@jsverse/transloco';

/** Subscription status → translation key (PENDING_PAYMENT is the display status of an unpaid ACTIVE one) */
export const SUBSCRIPTION_STATUS_KEYS: Record<string, string> = {
	ACTIVE: 'subscriptions.status.active',
	PAUSED: 'subscriptions.status.paused',
	COMPLETED: 'subscriptions.status.completed',
	CANCELLED: 'subscriptions.status.cancelled',
	FAILED: 'subscriptions.status.failed',
	PENDING_PAYMENT: 'subscriptions.status.pendingPayment',
};

/** Subscription status → CSS class of its badge */
export const SUBSCRIPTION_STATUS_CLASSES: Record<string, string> = {
	ACTIVE: 'status-active',
	PAUSED: 'status-paused',
	COMPLETED: 'status-completed',
	CANCELLED: 'status-cancelled',
	FAILED: 'status-failed',
	PENDING_PAYMENT: 'status-paused',
};

/** Payment status → translation key */
export const SUBSCRIPTION_PAYMENT_STATUS_KEYS: Record<string, string> = {
	PENDING: 'subscriptions.paymentStatus.pending',
	PENDING_PAYMENT: 'subscriptions.paymentStatus.pendingPayment',
	PENDING_VERIFICATION: 'subscriptions.paymentStatus.pendingVerification',
	COMPLETED: 'subscriptions.paymentStatus.completed',
	REJECTED: 'subscriptions.paymentStatus.rejected',
	EXPIRED: 'subscriptions.paymentStatus.expired',
};

/** Translated label from one of the maps above; unknown statuses keep their raw value */
export function subscriptionLabel(keys: Record<string, string>, status: string, transloco: TranslocoService): string {
	return keys[status] ? transloco.translate(keys[status]) : status;
}
